var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"login\"><div class=\"wrapper-main reset-page resetpass\"><div class=\"container resetpass-container active\"><h2>Reset Your Password</h2><p>Please enter a new password for your account</p><form action=\"#\" method=\"#\" onsubmit=\"return false;\"><div class=\"field\"><h3>New Password</h3><input ng-model=\"password\" type=\"password\" class=\"password-input\"><password-guide></password-guide></div><h3>Confirm New Password</h3><input ng-model=\"password_again\" type=\"password\" class=\"password-input\"><flash-message></flash-message><input type=\"submit\" value=\"{{ resetting_password ? 'Submitting...' : 'Reset Password' }}\" ng-click=\"resetPwd()\" class=\"check-disabled sub-butt-reset\"></form></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/home/password_reset_confirm/password_reset_confirm.jade
// module id = 567
// module chunks = 0